/* eslint-disable no-console */
import { calculate, setPositions, encodeChirality, decodeChirality } from '@moleculeone/draw';
import type { Mol } from '@moleculeone/types';
// import { MTree } from '@molview/tree';

type RustchemProvider = {
  smilesToMol: (smiles: string) => Promise<Mol>;
  molfileToMol: (molfile: string) => Promise<Mol>;
  molToSmiles: (mol: string) => Promise<string>;
  molToMolfile: (mol: string) => Promise<string>;
  reactionToRxn: (params: string) => Promise<string>;
  processTargetSmiles: (smiles: string) => string;
};

function trimStr(str: string): string {
  return str.replace(/^\s+|\s+$/g, '');
}

export default class MoleculeConverter {
  rustchemProvider: RustchemProvider;

  constructor(rustchemProvider: any) {
    this.rustchemProvider = rustchemProvider;
  }

  async smilesToMol(smiles: string, params = {}): Promise<Mol> {
    try {
      // console.time("conver smiles to mol");
      const mol = await this.rustchemProvider?.smilesToMol(smiles);
      const positionedMol = setPositions(mol, calculate(mol, params));
      const res = decodeChirality(positionedMol);
      // console.timeEnd("conver smiles to mol");
      return res;
    } catch (error: any) {
      throw new Error('Failed to parse SMILES. ' + error.message);
    }
  }

  async molfileToMol(molfile: string, params = {}): Promise<Mol> {
    const sanitizedMolfile = molfile.replace(/\\n/g, '\n');

    // const consoleError = console.error;
    // // intercept uncaught exceptions in wasm
    // console.error = function (error) {
    //   error.uncaught = true;
    //   throw new GeneralError('Failed to parse Molfile.', {
    //     errors: [error],
    //   });
    // };

    try {
      const mol = await this.rustchemProvider?.molfileToMol(sanitizedMolfile);
      // console.error = consoleError;
      const positionedMol = setPositions(mol, calculate(mol, params));
      return decodeChirality(positionedMol);
    } catch (error: any) {
      // console.error = consoleError;

      // if (error.uncaught) {
      //   throw error;
      // }

      throw new Error('Failed to parse Molfile. ' + error.message);
    }
  }

  async molToSmiles(mol: Mol): Promise<string> {
    try {
      const encodedMol = encodeChirality(mol);
      return this.rustchemProvider?.molToSmiles(JSON.stringify(encodedMol));
    } catch (error: any) {
      throw new Error('Failed to parse Mol. ' + JSON.stringify(error));
    }
  }

  async molToMolfile(mol: Mol): Promise<string> {
    try {
      // FIXME: What's about chirality here?
      return this.rustchemProvider?.molToMolfile(JSON.stringify(mol));
    } catch (error: any) {
      throw new Error('Failed to parse Mol. ' + JSON.stringify(error));
    }
  }

  async reactionToRxn({ productSmiles, substrateSmiles = [] }: any): Promise<string> {
    const productMol = await this.smilesToMol(productSmiles);
    const substrateMols = await Promise.all(substrateSmiles.map((smiles: any) => this.smilesToMol(smiles)));

    const encodedReactionData = {
      product: encodeChirality(productMol),
      substrates: substrateMols.map(encodeChirality),
    };

    try {
      const rawResult = await this.rustchemProvider?.reactionToRxn(JSON.stringify(encodedReactionData));

      return trimStr(rawResult);
    } catch (error: any) {
      throw new Error('Failed to parse reaction SMILES. ' + error.message);
    }
  }

  processTargetSmiles(smiles: string) {
    return this.rustchemProvider.processTargetSmiles(smiles);
  }
}
